import { useAuthStore } from "../stores/authStore";
import { isAuthed } from "../models/authState";

export const useUserId = () =>
  useAuthStore((state) => (isAuthed(state) ? state.session.userId : undefined));
